import { List } from '@mui/material';
import { useNavigate, useLocation } from 'react-router';
import SidebarItem from './UIElements/SidebarItem';
import SidebarLogo from './UIElements/SidebarLogo';
import { LuPanelLeftOpen } from 'react-icons/lu';
import { LuPanelRightOpen } from 'react-icons/lu';
import { getMenuItems } from './UIElements/sidebarConfig';
import { SIDEBAR_CONSTANTS } from './UIElements/sidebarConfig';
import { useSelector } from 'react-redux';

/**
 * Main sidebar navigation component
 * Provides collapsible navigation with menu items
 * @param {Object} props - Component props
 * @param {boolean} props.isSidebarOpen - Controls sidebar collapsed/expanded state
 */
const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const drawerWidth = isSidebarOpen
    ? SIDEBAR_CONSTANTS.COLLAPSED_WIDTH
    : SIDEBAR_CONSTANTS.WIDTH;

  const handleRouteChange = (route) => {
    navigate(route);
  };

  const isSelected = (route) =>
    location.pathname === route || location.pathname.startsWith(route + '/');
  const { userDetails, userPermissions, webServices } = useSelector(
    (state) => state.auth?.successData ?? {},
  );
  const MENU_ITEMS = getMenuItems(userDetails, userPermissions, webServices);
  return (
    <div
      style={{ width: drawerWidth, transition: SIDEBAR_CONSTANTS.TRANSITION }}
      className='bg-[#1e3a8a] h-full flex flex-col'
    >
      <div className='h-[55px] bg-[#2A489E] flex items-center overflow-hidden'>
        <SidebarLogo />
      </div>

      <List sx={{ mt: 2, overflow: 'hidden' }}>
        {MENU_ITEMS.map((item) => (
          <SidebarItem
            key={item.id}
            route={item.route}
            label={item.label}
            icon={item.icon}
            isSelected={isSelected(item.route)}
            isSidebarOpen={isSidebarOpen}
            onClick={handleRouteChange}
            className={item.className}
          />
        ))}
      </List>
      <div
        className='mt-auto mx-2 mb-2 h-10 bg-[#3f5eb5]  rounded text-white flex items-center justify-center cursor-pointer'
        onClick={() => setIsSidebarOpen((prev) => !prev)}
      >
        {isSidebarOpen ? (
          <div className='flex'>
            <LuPanelLeftOpen size='24' />
          </div>
        ) : (
          <div className='flex  overflow-hidden'>
            <LuPanelRightOpen size='24' />
            &nbsp;&nbsp; Hide
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
